// icon.js (в корне проекта)
import React from "react";

// ВАЖНО: в CRA svg импортируются вот так:
import { ReactComponent as ArrowDownArrowUp } from "../icons/svg/arrow-down-arrow-up.svg";
import { ReactComponent as ArrowDownToSquare } from "../icons/svg/arrow-down-to-square.svg";
import { ReactComponent as ArrowSmDown } from "../icons/svg/arrow-sm-down.svg";
import { ReactComponent as ArrowSmLeft } from "../icons/svg/arrow-sm-left.svg";
import { ReactComponent as ArrowSmRight } from "../icons/svg/arrow-sm-right.svg";
import { ReactComponent as ArrowUpFromBracket } from "../icons/svg/arrow-up-from-bracket.svg";
import { ReactComponent as ArrowUpFromSquares } from "../icons/svg/arrow-up-from-square.svg";
import { ReactComponent as ArrowUpRight } from "../icons/svg/arrow-up-right.svg";
import { ReactComponent as ArrowUp } from "../icons/svg/arrow-up.svg";
import { ReactComponent as ArrowsLeftRight } from "../icons/svg/arrows-left-right.svg";
import { ReactComponent as ArrowsUpDown } from "../icons/svg/arrows-up-down.svg";
import { ReactComponent as BagShoppingFilled } from "../icons/svg/bag-shopping.filled.svg";
import { ReactComponent as BagShopping } from "../icons/svg/bag-shopping.svg";
import { ReactComponent as BasketShoppingAlt1 } from "../icons/svg/basket-shopping-alt-1.svg";
import { ReactComponent as BasketShoppingAlt } from "../icons/svg/basket-shopping-alt.svg";
import { ReactComponent as BellAlt } from "../icons/svg/bell-alt.svg";
import { ReactComponent as BoltFilled } from "../icons/svg/bolt.filled.svg";
import { ReactComponent as Bolt } from "../icons/svg/bolt.svg";
import { ReactComponent as BoxArchive } from "../icons/svg/box-archive.svg";
import { ReactComponent as BriefcaseAlt1 } from "../icons/svg/briefcase-alt-1.svg";
import { ReactComponent as BriefcaseAlt } from "../icons/svg/briefcase-alt.svg";
import { ReactComponent as Calendar } from "../icons/svg/calendar.svg";
import { ReactComponent as Camera } from "../icons/svg/camera.svg";
import { ReactComponent as Check } from "../icons/svg/check.svg";
import { ReactComponent as ChevronDown } from "../icons/svg/chevron-down.svg";
import { ReactComponent as ChevronLeft } from "../icons/svg/chevron-left.svg";
import { ReactComponent as ChevronRight } from "../icons/svg/chevron-right.svg";
import { ReactComponent as ChevronDownSmall24 } from "../icons/svg/chevron.down.small.24.svg";
import { ReactComponent as ChevronRightSmall24 } from "../icons/svg/chevron.right.small.24.svg";
import { ReactComponent as CircleDashed } from "../icons/svg/circle-dashed.svg";
import { ReactComponent as CircleExclamation } from "../icons/svg/circle-exclamation.svg";
import { ReactComponent as CircleInformation } from "../icons/svg/circle-information.svg";
import { ReactComponent as Clear } from "../icons/svg/Clear.svg";
import { ReactComponent as Clock } from "../icons/svg/clock.svg";
import { ReactComponent as Coin } from "../icons/svg/Coin.svg";
import { ReactComponent as CoinAlternative } from "../icons/svg/coin alternative.svg";
import { ReactComponent as ColorShape } from "../icons/svg/color shape.svg";
import { ReactComponent as CreditCard } from "../icons/svg/credit-card.svg";
import { ReactComponent as Dismiss } from "../icons/svg/dismiss.svg";
import { ReactComponent as DoorClosed } from "../icons/svg/door-closed.svg";
import { ReactComponent as DotsHorizontal } from "../icons/svg/dots-horizontal.svg";
import { ReactComponent as DotsVertical } from "../icons/svg/dots-vertical.svg";
import { ReactComponent as Exit } from "../icons/svg/exit.svg";
import { ReactComponent as EyeSlash } from "../icons/svg/eye-slash.svg";
import { ReactComponent as Eye } from "../icons/svg/eye.svg";
import { ReactComponent as FaceFrown } from "../icons/svg/face-frown.svg";
import { ReactComponent as FileCopy } from "../icons/svg/file-copy.svg";
import { ReactComponent as GamingPadAll1 } from "../icons/svg/gaming-pad-alt-1.svg";
import { ReactComponent as Gear } from "../icons/svg/gear.svg";
import { ReactComponent as GiftAlt } from "../icons/svg/gift-alt.svg";
import { ReactComponent as GripDotsVertical } from "../icons/svg/grip-dots-vertical.svg";
import { ReactComponent as GripDots } from "../icons/svg/grip-dots.svg";
import { ReactComponent as HearFilled } from "../icons/svg/hear-filled.svg";
import { ReactComponent as Heart } from "../icons/svg/heart.svg";
import { ReactComponent as HeartFavorite } from "../icons/svg/heart-favorite.svg";
import { ReactComponent as HouseChimneyBlank } from "../icons/svg/house-chimney-blank.svg";
import { ReactComponent as HouseLine } from "../icons/svg/house-line.svg";
import { ReactComponent as HouseSmile } from "../icons/svg/house-smile.svg";
import { ReactComponent as ImageSquare } from "../icons/svg/image-square.svg";
import { ReactComponent as LocationArrow } from "../icons/svg/location-arrow.svg";
import { ReactComponent as LocationPinFilled } from "../icons/svg/location-pin-filled.svg";
import { ReactComponent as LocationPin } from "../icons/svg/location-pin.svg";
import { ReactComponent as Mail } from "../icons/svg/mail.svg";
import { ReactComponent as MenuAlt1 } from "../icons/svg/menu-alt-1.svg";
import { ReactComponent as MessageCircleDots } from "../icons/svg/message-circle-dots.svg";
import { ReactComponent as MessageCircle } from "../icons/svg/message-circle.svg";
import { ReactComponent as Minus } from "../icons/svg/minus.svg";
import { ReactComponent as MopedFilled } from "../icons/svg/moped filled.svg";
import { ReactComponent as Moped } from "../icons/svg/moped.svg";
import { ReactComponent as Paperclip } from "../icons/svg/paperclip.svg";
import { ReactComponent as Pen } from "../icons/svg/pen.svg";
import { ReactComponent as Percentage } from "../icons/svg/percentage.svg";
import { ReactComponent as Phone } from "../icons/svg/phone.svg";
import { ReactComponent as PlusLarge } from "../icons/svg/plus-large.svg";
import { ReactComponent as Plus } from "../icons/svg/plus.svg";
import { ReactComponent as Profile } from "../icons/svg/profile.svg";
import { ReactComponent as SearchAlt } from "../icons/svg/search-alt.svg";
import { ReactComponent as Search } from "../icons/svg/search.svg";
import { ReactComponent as Share } from "../icons/svg/Share.svg";
import { ReactComponent as SlidersSimple1 } from "../icons/svg/sliders-simple-1.svg";
import { ReactComponent as SlidersSimple } from "../icons/svg/sliders-simple.svg";
import { ReactComponent as StarFilled } from "../icons/svg/star-filled.svg";
import { ReactComponent as Star } from "../icons/svg/star.svg";
import { ReactComponent as Trash } from "../icons/svg/trash.svg";
import { ReactComponent as TriangleExclamation } from "../icons/svg/triangle-exclamation.svg";
import { ReactComponent as Truck } from "../icons/svg/truck.svg";
import { ReactComponent as Unlock } from "../icons/svg/unlock.svg";
import { ReactComponent as UserAlt1 } from "../icons/svg/user-alt-1.svg";
import { ReactComponent as User } from "../icons/svg/user.svg";
import { ReactComponent as Wallet } from "../icons/svg/wallet.svg";
import { ReactComponent as DismissWhite } from "../icons/svg/dismiss-white.svg";

const icons = {
  // Стрелки
  "arrow-up": ArrowUp,
  "arrow-down": ArrowSmDown,
  "arrow-left": ArrowSmLeft,
  "arrow-right": ArrowSmRight,
  "arrow-sort": ArrowDownArrowUp,
  "arrow-exchange": ArrowsLeftRight,
  "arrow-resize": ArrowsUpDown,
  "arrow-external": ArrowUpRight,
  "arrow-upload": ArrowUpFromBracket,
  "arrow-expand": ArrowUpFromSquares,
  "arrow-download": ArrowDownToSquare,

  // Шевроны
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-down-small": ChevronDownSmall24,
  "chevron-right-small": ChevronRightSmall24,

  // Действия
  check: Check,
  plus: Plus,
  "plus-large": PlusLarge,
  minus: Minus,
  search: Search,
  "search-alt": SearchAlt,
  close: Clear,
  dismiss: Dismiss,
  "dismiss-white": DismissWhite,
  trash: Trash,
  edit: Pen,
  copy: FileCopy,
  share: Share,
  lock: Unlock,
  exit: Exit,

  // Навигация
  menu: MenuAlt1,
  "dots-h": DotsHorizontal,
  "dots-v": DotsVertical,
  "grip-h": GripDots,
  "grip-v": GripDotsVertical,

  // Состояния
  heart: Heart,
  "heart-favorite": HeartFavorite,
  "heart-filled": HearFilled,
  star: Star,
  "star-filled": StarFilled,
  bell: BellAlt,
  eye: Eye,
  "eye-closed": EyeSlash,

  // Коммерция
  cart: BasketShoppingAlt,
  "cart-alt": BasketShoppingAlt1,
  bag: BagShopping,
  "bag-filled": BagShoppingFilled,
  wallet: Wallet,
  "credit-card": CreditCard,
  "price-tag": Percentage,
  gift: GiftAlt,

  // Доставка
  truck: Truck,
  moped: Moped,
  "moped-filled": MopedFilled,
  location: LocationPin,
  "location-filled": LocationPinFilled,
  "location-arrow": LocationArrow,

  // Время
  clock: Clock,
  calendar: Calendar,

  // Пользователь
  user: User,
  "user-alt": UserAlt1,
  profile: Profile,

  // Сообщения
  mail: Mail,
  message: MessageCircle,
  "message-dots": MessageCircleDots,

  // Файлы и медиа
  image: ImageSquare,
  camera: Camera,
  attachment: Paperclip,
  archive: BoxArchive,

  // Настройки
  settings: Gear,
  sliders: SlidersSimple,
  "sliders-alt": SlidersSimple1,

  // Предметы
  house: HouseSmile,
  "house-line": HouseLine,
  "house-blank": HouseChimneyBlank,
  briefcase: BriefcaseAlt,
  "briefcase-alt": BriefcaseAlt1,
  phone: Phone,
  door: DoorClosed,
  gamepad: GamingPadAll1,

  // Эмоции
  smile: HouseSmile,
  frown: FaceFrown,

  // Формы и значки
  "circle-info": CircleInformation,
  "circle-warning": CircleExclamation,
  "circle-dashed": CircleDashed,
  "triangle-warning": TriangleExclamation,
  bolt: Bolt,
  "bolt-filled": BoltFilled,
  coin: Coin,
  shape: ColorShape,
};

const Icon = ({
  name,
  width = 24,
  height = 24,
  color = "#000000",
  gradient,
  ...props
}) => {
  const IconComponent = icons[name];

  if (!IconComponent) {
    console.warn(`Иконка "${name}" не найдена`);
    return (
      <div
        style={{
          width,
          height,
          backgroundColor: "#f5f5f5",
        }}
      />
    );
  }

  // ⚠️ Упрощённая обработка градиента: берём первый цвет
  if (gradient && gradient.colors && gradient.colors.length > 0) {
    const fillColor = gradient.colors[0];
    return (
      <IconComponent
        width={width}
        height={height}
        fill={fillColor}
        {...props}
      />
    );
  }

  return (
    <IconComponent width={width} height={height} fill={color} {...props} />
  );
};

export const availableIcons = Object.keys(icons);
export default Icon;